(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["eagle-store-locator"] && !Shopify.designMode) return;
  try {
    
  class EagleStoreLocator extends HTMLElement {
    connectedCallback() {
      const data = JSON.parse(this.querySelector('[data-role="data"]').textContent);
      /* A dealer needs a usable coordinate pair to be mappable. Blank settings
         arrive as null (see the JSON island above) and non-numeric text still
         coerces to 0, so also reject out-of-range values and the (0,0) origin —
         no dealer is in the Gulf of Guinea, and a bad pin drags fitBounds. */
      this.stores = data.stores.filter(
        (s) =>
          Number.isFinite(s.lat) &&
          Number.isFinite(s.lng) &&
          Math.abs(s.lat) <= 90 &&
          Math.abs(s.lng) <= 180 &&
          (s.lat !== 0 || s.lng !== 0)
      );
      this.assets = data;
      this.listEl = this.querySelector('[data-role="list"]');
      this.statusEl = this.querySelector('[data-role="status"]');
      this.announcerEl = this.querySelector('[data-role="announcer"]');
      this.origin = null;

      this.querySelector('.store-locator__search').addEventListener('submit', (e) => {
        e.preventDefault();
        this.geocode(this.querySelector('[data-role="query"]').value.trim());
      });
      this.querySelector('[data-role="locate"]').addEventListener('click', () => this.locate());

      this.renderList();
      this.whenLeafletReady(() => this.initMap());
    }

    /* leaflet.js is deferred, so it may land after this element upgrades.
       Poll for it, but give up after ~10s so a failed/blocked script can't
       leave an interval running for the life of the page. The dealer list
       and Directions links work without the map. */
    whenLeafletReady(fn) {
      if (window.L) return fn();
      let waited = 0;
      const timer = setInterval(() => {
        if (window.L) {
          clearInterval(timer);
          fn();
        } else if ((waited += 50) >= 10000) {
          clearInterval(timer);
        }
      }, 50);
    }

    initMap() {
      this.map = L.map(this.querySelector('[data-role="map"]'), { scrollWheelZoom: false });
      L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
        maxZoom: 19,
        attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
      }).addTo(this.map);

      const icon = L.icon({
        iconUrl: this.assets.icon,
        iconRetinaUrl: this.assets.icon2x,
        shadowUrl: this.assets.shadow,
        iconSize: [25, 41],
        iconAnchor: [12, 41],
        popupAnchor: [1, -34],
        shadowSize: [41, 41],
      });

      /* The marker is held on the store object, not looked up by index:
         setOrigin() re-sorts this.stores by distance, so any parallel
         array would point at the wrong dealer after a search. */
      this.markers = this.stores.map((store) => {
        const marker = L.marker([store.lat, store.lng], { icon }).addTo(this.map);
        store.marker = marker;
        const popup = document.createElement('div');
        const name = document.createElement('strong');
        name.textContent = store.name;
        const address = document.createElement('div');
        address.textContent = `${store.address}, ${store.city}`;
        const directions = document.createElement('a');
        directions.href = this.directionsUrl(store);
        directions.target = '_blank';
        directions.rel = 'noopener noreferrer';
        directions.textContent = 'Directions';
        popup.append(name, address, directions);
        marker.bindPopup(popup);
        return marker;
      });

      /* A search can resolve before the deferred leaflet.js arrives — geolocation
         with a warm permission returns in milliseconds. setOrigin() skips all its
         map work when the map doesn't exist yet, so replay it here rather than
         framing the whole province and dropping the visitor's origin marker. */
      if (this.origin) {
        this.setOrigin(this.origin.lat, this.origin.lng, { announce: false });
      } else if (this.stores.length) {
        this.map.fitBounds(L.latLngBounds(this.stores.map((s) => [s.lat, s.lng])).pad(0.15));
      } else {
        this.map.setView([53.5, -113.5], 5);
      }
    }

    directionsUrl(store) {
      return `https://www.google.com/maps/dir/?api=1&destination=${store.lat},${store.lng}`;
    }

    /* Dealer website URLs come from theme settings. Only http(s) is allowed
       through, so a malformed or "javascript:" value renders no link
       instead of an executable one. */
    safeUrl(value) {
      try {
        const url = new URL(value, window.location.origin);
        return url.protocol === 'http:' || url.protocol === 'https:' ? url.href : null;
      } catch (error) {
        return null;
      }
    }

    distanceKm(a, b) {
      const rad = Math.PI / 180;
      const dLat = (b.lat - a.lat) * rad;
      const dLng = (b.lng - a.lng) * rad;
      const h = Math.sin(dLat / 2) ** 2
        + Math.cos(a.lat * rad) * Math.cos(b.lat * rad) * Math.sin(dLng / 2) ** 2;
      return 6371 * 2 * Math.atan2(Math.sqrt(h), Math.sqrt(1 - h));
    }

    setStatus(message) {
      this.statusEl.hidden = !message;
      this.statusEl.textContent = message || '';
      this.announce(message);
    }

    /* Speaks to assistive tech without touching the visible layout. */
    announce(message) {
      if (this.announcerEl) this.announcerEl.textContent = message || '';
    }

    /* Shared by the card click (a mouse convenience) and the per-card
       "Show on map" button (the keyboard-reachable path). Moving the map is
       invisible to a screen reader, so the result is also announced. */
    focusStore(store, card) {
      this.querySelectorAll('.store-locator__card').forEach((el) => el.classList.remove('is-active'));
      card.classList.add('is-active');
      if (this.map) {
        this.map.setView([store.lat, store.lng], 13);
        if (store.marker) store.marker.openPopup();
        this.announce(`Showing ${store.name} on the map.`);
      } else {
        this.announce(`${store.name} selected. The map is still loading.`);
      }
    }

    async geocode(query) {
      if (!query) return;
      this.setStatus('Searching…');
      try {
        const response = await fetch(
          `https://nominatim.openstreetmap.org/search?format=json&limit=1&countrycodes=ca&q=${encodeURIComponent(query)}`
        );
        const results = await response.json();
        if (!results.length) {
          this.setStatus('Location not found — try a city name or postal code.');
          return;
        }
        this.setOrigin(Number(results[0].lat), Number(results[0].lon));
      } catch (error) {
        this.setStatus('Search is unavailable right now — please try again.');
      }
    }

    locate() {
      if (!navigator.geolocation) return;
      this.setStatus('Finding your location…');
      navigator.geolocation.getCurrentPosition(
        (position) => this.setOrigin(position.coords.latitude, position.coords.longitude),
        () => this.setStatus('Could not get your location — check browser permissions.')
      );
    }

    /* `announce: false` is used when initMap() replays a search that resolved
       before the map existed — the visitor already heard the result. */
    setOrigin(lat, lng, options = {}) {
      this.origin = { lat, lng };
      this.setStatus('');
      this.stores.forEach((store) => {
        store.distance = this.distanceKm(this.origin, store);
      });
      this.stores.sort((a, b) => a.distance - b.distance);
      this.renderList();

      /* Re-ordering the list is a silent, purely visual event. Without this a
         screen reader user hears nothing back from the search and has no way to
         tell it worked. */
      if (options.announce !== false) {
        const nearest = this.stores[0];
        this.announce(
          nearest
            ? `${this.stores.length} ${this.stores.length === 1 ? 'dealer' : 'dealers'} sorted by distance. ` +
                `Nearest is ${nearest.name}, ${nearest.distance.toFixed(1)} kilometres away.`
            : 'No dealers to show.'
        );
      }

      if (this.map) {
        if (this.originMarker) this.originMarker.remove();
        this.originMarker = L.circleMarker([lat, lng], {
          radius: 8,
          /* Reads more clearly against pale map tiles than the lighter fill. */
          color: '#dd963d',
          fillColor: '#dd963d',
          fillOpacity: 0.6,
        }).addTo(this.map);
        const nearest = this.stores[0];
        const bounds = L.latLngBounds([[lat, lng]]);
        if (nearest) bounds.extend([nearest.lat, nearest.lng]);
        this.map.fitBounds(bounds.pad(0.35));
      }
    }

    renderList() {
      this.listEl.textContent = '';
      this.stores.forEach((store) => {
        const item = document.createElement('li');
        item.className = 'store-locator__card';

        /* h2: each dealer sits directly under the page's h1 heading. */
        const name = document.createElement('h2');
        name.className = 'store-locator__name';
        name.textContent = store.name;

        const address = document.createElement('p');
        address.className = 'store-locator__address';
        address.textContent = `${store.address}\n${store.city}`;
        address.style.whiteSpace = 'pre-line';

        item.append(name, address);

        if (store.phone) {
          const phone = document.createElement('p');
          phone.className = 'store-locator__address';
          phone.textContent = store.phone;
          item.append(phone);
        }

        if (typeof store.distance === 'number') {
          const distance = document.createElement('p');
          distance.className = 'store-locator__distance';
          distance.textContent = `${store.distance.toFixed(1)} km`;
          item.append(distance);
        }

        const links = document.createElement('div');
        links.className = 'store-locator__links';

        /* Every control names its own dealer. Tabbing this list otherwise reads
           as "Directions, Directions, Directions…" nine times over, with no way
           to tell which dealer any of them belongs to. */
        const showOnMap = document.createElement('button');
        showOnMap.type = 'button';
        showOnMap.textContent = 'Show on map';
        showOnMap.setAttribute('aria-label', `Show ${store.name} on the map`);
        showOnMap.addEventListener('click', () => this.focusStore(store, item));
        links.append(showOnMap);

        const directions = document.createElement('a');
        directions.href = this.directionsUrl(store);
        directions.target = '_blank';
        directions.rel = 'noopener noreferrer';
        directions.textContent = 'Directions';
        directions.setAttribute('aria-label', `Directions to ${store.name} (opens in a new tab)`);
        links.append(directions);

        const websiteUrl = store.website ? this.safeUrl(store.website) : null;
        if (websiteUrl) {
          const site = document.createElement('a');
          site.href = websiteUrl;
          site.target = '_blank';
          site.rel = 'noopener noreferrer';
          site.textContent = 'Website';
          site.setAttribute('aria-label', `${store.name} website (opens in a new tab)`);
          links.append(site);
        }

        item.append(links);

        /* Clicking the card is a mouse affordance layered over the button above,
           so it must not double-fire when a control inside it was the target. */
        item.addEventListener('click', (event) => {
          if (event.target.closest('a, button')) return;
          this.focusStore(store, item);
        });

        this.listEl.append(item);
      });
    }
  }

  if (!customElements.get('eagle-store-locator')) {
    customElements.define('eagle-store-locator', EagleStoreLocator);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eagle-warranty-registration"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('eagle-warranty-registration')) {
    /**
     * Passcode gate, expiry-date pre-fill and date formatting for the
     * warranty registration form. See the comment at the top of
     * sections/eagle-warranty-registration.liquid for what the gate is and
     * is not.
     */
    class EagleWarrantyRegistration extends HTMLElement {
      static STORAGE_KEY = 'eagle-warranty-unlocked';

      connectedCallback() {
        this.hash = (this.dataset.passcodeHash || '').trim().toLowerCase();
        this.salt = this.dataset.salt || '';
        this.years = parseInt(this.dataset.warrantyYears, 10) || 2;
        this.gate = this.querySelector('[data-role="gate"]');
        this.formWrap = this.querySelector('[data-role="form-wrap"]');
        this.form = this.formWrap && this.formWrap.querySelector('form');

        const unlockForm = this.querySelector('[data-role="unlock-form"]');
        if (unlockForm) {
          unlockForm.addEventListener('submit', (event) => {
            event.preventDefault();
            this.tryUnlock();
          });
        }

        const lockButton = this.querySelector('[data-role="lock"]');
        if (lockButton) lockButton.addEventListener('click', () => this.lock());

        this.wireDates();
        if (this.form) this.form.addEventListener('submit', (event) => this.beforeSubmit(event));

        // The theme editor already shows the form.
        if (this.hasAttribute('data-design-mode')) return;

        // Survives the reload after a submission, so the success message shows.
        if (this.hash && this.readUnlocked() === this.hash) this.reveal(false);
      }

      async tryUnlock() {
        const input = this.querySelector('[data-role="passcode"]');
        const error = this.querySelector('[data-role="gate-error"]');
        const entered = (input.value || '').trim();

        let matches = false;
        if (entered && this.hash && window.crypto && window.crypto.subtle) {
          matches = (await this.sha256(`${entered}:${this.salt}`)) === this.hash;
        }

        if (!matches) {
          error.hidden = false;
          input.select();
          return;
        }

        error.hidden = true;
        input.value = '';
        this.writeUnlocked(this.hash);
        this.reveal(true);
      }

      reveal(moveFocus) {
        this.gate.hidden = true;
        this.formWrap.hidden = false;

        const status = this.formWrap.querySelector('[data-role="status"]');
        const firstField = this.formWrap.querySelector('input:not([type="hidden"]), select');
        if (status) {
          status.focus();
        } else if (moveFocus && firstField) {
          firstField.focus();
        }
      }

      lock() {
        this.writeUnlocked(null);
        this.formWrap.hidden = true;
        this.gate.hidden = false;
        const input = this.querySelector('[data-role="passcode"]');
        if (input) input.focus();
      }

      wireDates() {
        this.purchase = this.querySelector('[data-role="purchase-date"]');
        this.expiry = this.querySelector('[data-role="expiry-date"]');
        this.purchaseValue = this.querySelector('[data-role="purchase-date-value"]');
        this.expiryValue = this.querySelector('[data-role="expiry-date-value"]');
        if (!this.purchase || !this.expiry) return;

        // Once staff type an expiry themselves, a later purchase-date change
        // leaves it alone; clearing it hands control back to the pre-fill.
        let expiryTouched = false;

        const onPurchase = () => {
          if (!expiryTouched && this.purchase.value) {
            this.expiry.value = this.addYears(this.purchase.value, this.years);
          }
          this.syncDates();
        };
        this.purchase.addEventListener('input', onPurchase);
        this.purchase.addEventListener('change', onPurchase);

        const onExpiry = () => {
          expiryTouched = this.expiry.value !== '';
          this.syncDates();
        };
        this.expiry.addEventListener('input', onExpiry);
        this.expiry.addEventListener('change', onExpiry);
      }

      syncDates() {
        this.purchaseValue.value = this.toRecordFormat(this.purchase.value);
        this.expiryValue.value = this.toRecordFormat(this.expiry.value);

        // ISO dates compare correctly as strings.
        const backwards = this.purchase.value && this.expiry.value && this.expiry.value <= this.purchase.value;
        this.expiry.setCustomValidity(backwards ? 'The expiry date must be after the date of purchase.' : '');
      }

      beforeSubmit(event) {
        this.syncDates();

        // Only reachable if the copy above failed: never send a registration
        // with no dates on it.
        if (!this.purchaseValue.value || !this.expiryValue.value) {
          event.preventDefault();
          this.purchase.reportValidity();
          return;
        }

        this.form.querySelectorAll('[data-uppercase]').forEach((field) => {
          field.value = field.value.trim().toUpperCase();
        });
      }

      /** 2026-09-11 + 2 -> 2028-09-11; Feb 29 lands on Feb 28 in a non-leap year. */
      addYears(iso, years) {
        const [year, month, day] = iso.split('-').map(Number);
        const targetYear = year + years;
        const daysInMonth = new Date(Date.UTC(targetYear, month, 0)).getUTCDate();
        const pad = (value) => String(value).padStart(2, '0');
        return `${targetYear}-${pad(month)}-${pad(Math.min(day, daysInMonth))}`;
      }

      /** 2026-09-11 -> 09/11/2026, the format the warranty team's records use. */
      toRecordFormat(iso) {
        if (!iso) return '';
        const [year, month, day] = iso.split('-');
        return `${month}/${day}/${year}`;
      }

      async sha256(text) {
        const bytes = new TextEncoder().encode(text);
        const digest = await window.crypto.subtle.digest('SHA-256', bytes);
        return Array.from(new Uint8Array(digest), (b) => b.toString(16).padStart(2, '0')).join('');
      }

      // Storage can throw (private browsing, blocked site data); the gate just
      // asks again on the next page load.
      readUnlocked() {
        try {
          return window.sessionStorage.getItem(EagleWarrantyRegistration.STORAGE_KEY);
        } catch (error) {
          return null;
        }
      }

      writeUnlocked(value) {
        try {
          if (value) {
            window.sessionStorage.setItem(EagleWarrantyRegistration.STORAGE_KEY, value);
          } else {
            window.sessionStorage.removeItem(EagleWarrantyRegistration.STORAGE_KEY);
          }
        } catch (error) {
          // Nothing to do: see readUnlocked.
        }
      }
    }

    customElements.define('eagle-warranty-registration', EagleWarrantyRegistration);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
